import { render, staticRenderFns } from "./add-madel.vue?vue&type=template&id=628b22cc"
import script from "./add-madel.vue?vue&type=script&lang=ts"
export * from "./add-madel.vue?vue&type=script&lang=ts"
import style0 from "./add-madel.vue?vue&type=style&index=0&id=628b22cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports